__turbopack_context__.v({
  "container": "MenuItem-module-scss-module__vHB2hG__container",
  "disabled": "MenuItem-module-scss-module__vHB2hG__disabled",
  "selected": "MenuItem-module-scss-module__vHB2hG__selected",
});
